import React, { useState } from "react";
import CarrierIntegrationIsEnabledModel from "./CarrierIntegrationIsEnabledModel";
import { CarrierIntegrationApi } from "services/apis/CarrierIntegrationApi";
import { handleError } from "services/util/ApiUtil";
type Props = {
  row: any; // This will contain the row data
  onEdit: (data: any) => void;
  onRefresh: () => void; 
};
type LockIconProps = {
  enabled: boolean;
  onClick: () => void;
};

const LockIcon = ({ enabled, onClick }: LockIconProps) => (
  <i
    className={`fa fa-solid ${enabled ? 'fa-lock pgreen-color' : 'fa-lock-open red-color'} action-icon`}
    onClick={()=> {}}
    data-toggle="tooltip"
    data-placement="top"
    title={enabled ? "Enabled" : "Disabled"}
  />
);

export const  CarrierActionsCell = (props: Props) => {
  const [showModal, setShowModal] = useState(false);
  const isEnabled = props.row.original.integrationEnabled;


  const handleLockClick = () => {
    setShowModal(true); 
  };

  const handleConfirm = () => {
    const payLoad = {
      integrationEnabled: isEnabled ? false : true,
      losingCarrier: 1,
      losingCarrierSpid: props?.row?.original?.losingCarrierSpid,
      carrierAccountId: props?.row?.original?.carrierAccountId,
      spid: [props?.row?.original?.spids]
    }
    CarrierIntegrationApi.update(payLoad, props.row.original.carrierIntegrationSettingId)
      .then((result) => {
        if(result) {
          props.onRefresh();
        }
      }).catch((error) => handleError(error))
      .finally(() => {
        setShowModal(false);
      });
  };
    const handleCancel = () => {
    setShowModal(false);
  };
    return (
    <>
      <LockIcon enabled={props.row.original.integrationEnabled} onClick={handleLockClick}/>
      <i
        className="fa fa-edit action-icon"
        onClick={() => props.onEdit(props.row.original)}
        data-toggle="tooltip"
        data-placement="top"
        title="Edit"
      />
      <CarrierIntegrationIsEnabledModel
        isOpen={showModal}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        currentStatus={isEnabled}
      />
    </>
  );
};

export default CarrierActionsCell